import React from "react";
import moment from "moment";
import flattenObject from "../../../utils/flattenObject";

const warrTemplate = {
  _id: "",
  administrationDate: "",
  requestedVials: "",
  invoiceNumber: "",
  purchaseDate: "",
  purchaseOrderNumber: "",
  contact: {
    hospitalName: "",
    authorizedRepresentativeName: "",
    authorizedRepresentativeTitle: "",
    email: "",
    phoneNumber: "",
  },
  shipping: {
    address1: "",
    address2: "",
    city: "",
    state: "",
    zipCode: "",
  },
  licenseURL: "",
  authorizationVerification: "",
  termsVerify: "",
  eSignature: "",
  date: "",
  warrantyApproved: "",
  warrantyDenied: "",
  note: "",
  createdAt: "",
};

const wastageTemplate = {
  _id: "",
  requestedVials: "",
  invoiceNumber: "",
  purchaseOrderNumber: "",
  purchaseDate: "",
  mixedDate: "",
  contact: {
    hospitalName: "",
    authorizedRepresentativeName: "",
    authorizedRepresentativeTitle: "",
    email: "",
    phoneNumber: "",
  },
  shipping: {
    address1: "",
    address2: "",
    city: "",
    state: "",
    zipCode: "",
  },
  licenseURL: "",
  authorizationVerification: "",
  termsVerify: "",
  eSignature: "",
  date: "",
  wastageApproved: "",
  destructionApproved: "",
  finalApproved: "",
  wastageDenied: "",
  destructionFormId: "",
  note: "",
  createdAt: "",
};

const destTemplate = {
  _id: "",
  destructionApproved: "",
  vialsDestroyed: "",
  hospitalName: "",
  hospitalAddress: "",
  authorizedRepresentativeName: "",
  authorizedRepresentativeTitle: "",
  email: "",
  phone: "",
  eSignature: "",
  date: "",
  note: "",
  createdAt: "",
};

const templates = {
  waste: wastageTemplate,
  dest: destTemplate,
  warr: warrTemplate,
};

const csvTag = "data:text/csv;charset=utf-8,";
function encodeCSV(tableType, records) {
  const columns = []
    .concat(
      Object.keys(
        flattenObject(Object.assign({}, templates[tableType], records[0]))
      )
    )
    .join(",");
  const rows = records
    .sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0))
    .map((v) => {
      return Object.entries(
        flattenObject(Object.assign({}, templates[tableType], v))
      )
        .sort(([aKey], [bKey]) => columns.indexOf(aKey) - columns.indexOf(bKey))
        .map(([key, value]) =>
          value.toString().includes(",")
            ? `"${value.toString()}"`
            : value.toString()
        )
        .join(",");
    })
    .join("\n");

  return `${csvTag}\n${columns}\n${rows}`;
}
export default function CSVexport({ records, tableType, cmp }) {
  function handleClick(e) {
    e.preventDefault();
    const link = document.createElement("a");
    link.setAttribute("href", encodeCSV(tableType, records));
    link.setAttribute(
      "download",
      `${tableType}-${moment().format("MM-DD-YYYY")}.csv`
    );
    document.body.appendChild(link);

    link.click();
  }

  return React.cloneElement(cmp, {
    onClick: handleClick,
  });
}
